import { Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { View } from "../../View";
import { palette } from "../../../theme/palette";
import { APPLY, CANCEL } from "../../../consts/strings";
import { useDispatch } from "react-redux";
import {
  setSelectedSimulationPercentage,
  setSelectSimulatedOverlayOpen,
} from "../../../reducers/ownApp";

const useStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    padding: "1.5rem",
    gap: "1rem",
  },
  blue: {
    background: palette.btn.blueFill,
    color: palette.typography.white.high,
    border: palette.btn.blueBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.blueFill,
    },
    cursor: "pointer",
  },
  yellow: {
    background: palette.btn.yellowFill,
    color: palette.typography.black.high,
    border: palette.btn.yelloBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.yellowFill,
    },
  },
});

export const SelectSimulatedOverlayAction = ({
  onCancel,
  modalValue,
  selectOverlay,
}) => {
  const styles = useStyles();
  const dispatch = useDispatch();

  const onModalSubmit = () => {
    dispatch(setSelectedSimulationPercentage(modalValue));
    dispatch(setSelectSimulatedOverlayOpen(false));
    selectOverlay(modalValue);
  };

  return (
    <View className={styles.container}>
      <Button
        className={styles.yellow}
        variant={"contained"}
        onClick={onCancel}
      >
        {CANCEL}
      </Button>
      <Button
        className={styles.blue}
        variant={"contained"}
        onClick={() => {
          if (modalValue !== null) onModalSubmit();
        }}
      >
        {APPLY}
      </Button>
    </View>
  );
};
